'use client';
//TODO: Complete
import StorageSizeCardImage from '../StorageSizeCardImage/StorageSizeCardImage';
import styles from './storagesizecardadvanced.module.scss';
import { ReplaceOrgName } from '@/app/helpers/clientUtilityHelper';
import { iStorageSizeAdvanced } from '@/app/models/storageSizeAdvanced';
import LinkElement from '../General/LinkElement';
import { eButtonColorTheme } from '@/app/models/enum/eButtonColorTheme';
import { eChevronPosition } from '@/app/models/enum/chevronPosition';
import InformationBubble from '../InformationBubble/InformationBubble';

interface Props {
    storage: iStorageSizeAdvanced,
    translations: any,
    temporaryOrgName?: string;
    onClick?: (card: iStorageSizeAdvanced) => void;
    isSmallCard?: boolean;
    className?: string;
    country: string;
    useCustomStyling?: boolean;
    isOnStartPage?: boolean;
    isOnAreaPage?: boolean;
    isOnSizeByAreaPage?: boolean;
}

export default function StorageSizeCardAdvanced({ storage, translations, temporaryOrgName, onClick, isSmallCard = false, className = "", country, useCustomStyling = false, isOnStartPage = false, isOnAreaPage = false, isOnSizeByAreaPage = false }: Props) {
    const handleLinkClick = () => {
        onClick && onClick(storage);
    };

    return (
        <div className={`no-underline relative text-center block rounded-3xl border border-gs-grey p-4 pb-6 hover:border-gs-black-500 focus:outline-none ${className}`}>
            <InformationBubble title="Information" className="absolute" closeTranslation={translations.general.closePopup}>
                <div className="w-full">
                    <h3>
                        {storage.infoTitle}</h3>
                    <p>{storage.infoDescription}</p>
                    <h3>{translations.blocks.storageSizesAdvanced.infoList.title}</h3>
                    <p>
                        <span className="inline-block w-full">
                            <span>{translations.blocks.storageSizesAdvanced.infoList.totalVolume}: </span>
                            <span>{storage.infoVolumeString} {translations.general.m3}</span>
                        </span>
                        <span className="inline-block w-full">
                            <span>{translations.blocks.storageSizesAdvanced.infoList.sizeGroup}: </span>
                            <span>{storage.name}</span>
                        </span>
                        <span className="inline-block w-full">
                            <span>{translations.blocks.storageSizesAdvanced.infoList.roomType}: </span>
                            {storage.isHeated && !storage.isCold && (
                                <>{translations.general.heatedUnits}</>
                            )}
                            {!storage.isHeated && storage.isCold && (
                                <>{translations.general.coldUnits}</>
                            )}
                            {storage.isHeated && storage.isCold && (
                                <>{translations.general.heatedUnits} & {translations.general.coldUnits}</>
                            )}
                        </span>
                        <span className="inline-block w-full">
                            <span>{translations.blocks.storageSizesAdvanced.infoList.access}: </span>
                            <span>
                                {storage.infoAccessString}
                            </span>
                            
                        </span>
                        <span className="inline-block w-full">
                            {storage.isGroundFloor ? (
                                <img src="/assets/img/icons/wheelchair-solid.svg" title={translations.pages.order.unitInformation.isHandicapAccessible} alt={translations.pages.order.unitInformation.isHandicapAccessible} className="inline-block ml-1 w-[18px] h-[18px]" />
                            ) : (
                                <img src="/assets/img/icons/icon-wheelchair-not.svg" title={translations.pages.order.unitInformation.isNotHandicapAccessible} alt={translations.pages.order.unitInformation.isNotHandicapAccessible} className="inline-block ml-1 w-[18px] h-[18px]" />
                            )}
                        </span>
                    </p>
                </div>
            </InformationBubble>
            <div className="absolute right-4 top-[15px]">
                {storage.isGroundFloor ? (
                    <img src="/assets/img/icons/wheelchair-solid.svg" title={translations.pages.order.unitInformation.isHandicapAccessible} alt={translations.pages.order.unitInformation.isHandicapAccessible} className="inline-block ml-1 w-[18px] h-[18px]" />
                ) : (
                    <img src="/assets/img/icons/icon-wheelchair-not.svg" title={translations.pages.order.unitInformation.isNotHandicapAccessible} alt={translations.pages.order.unitInformation.isNotHandicapAccessible} className="inline-block ml-1 w-[18px] h-[18px]" />
                )}
            </div>
            {isSmallCard ? (
                <div className="textSmall font-bold">
                    {isOnAreaPage ? (
                        <>
                            {storage.facility} - {storage.isHeated ? translations.general.heatedUnits : storage.isCold ? translations.general.coldUnits : ""} - {storage.size} m<span className="align-super text-[10.5px]">2</span>
                        </>
                    ) : (
                        <>
                            {storage.isHeated ? translations.general.heatedUnits : storage.isCold ? translations.general.coldUnits : ""} - {storage.size} m<span className="align-super text-[10.5px]">2</span>
                        </>
                    )}
                </div>
            ) : (
                <>
                    {isOnSizeByAreaPage && (
                        <h3 className="mb-0 h-[30px]">
                            {storage.facility}
                        </h3>
                    )}
                    {storage.isLastOne && !isOnSizeByAreaPage && (
                        <h3 className="mb-0 h-[30px]">
                            {storage.isHeated && (
                                <>{translations.general.heatedUnits}</>
                            )}
                            {storage.isCold && (
                                <>{translations.general.coldUnits}</>
                            )}
                        </h3>
                    )}
                    {!storage.isLastOne && !isOnSizeByAreaPage && (
                        <div className="h-[30px]"></div>
                    )}
                    <div className="mb-2-i grid-col-1 grid sm:block md:grid xl:block">
                        <div className="text-small !mb-2 font-bold">
                            {storage.name}
                        </div>
                        <span className="font-bold font-color-green leading-tight text-[1.125rem] sm:text-[1.5rem] !mb-0 sm:mb-2 md:mb-0 xl:mb-5">{storage.size} m<span className="align-super text-[0.875rem]">2</span></span>

                        <span className="leading-tight text-[0.875rem] sm:text-[1rem] ml-1">({storage.volume} m<span className="align-super text-[0.75rem]">3</span>)</span>
                    </div>
                </>
            )
            }

            {!isSmallCard && (
                <div className={`inline-block rounded-lg bg-gray-50 mb-2 w-full ${styles.imageContainer} relative`}>
                    {(storage.isLastOne || storage.hasFewLeft) && (
                        <div className="absolute right-0 left-0 z-10 -m-4 mt-0">
                            <div className="grid w-full grid-cols-1 gap-2 ">
                                {storage.isLastOne && (
                                    <div className="bg-gs-black-50 py-1 lg:py-2 w-full text-[0.875rem] sm:text-[1rem] !mb-0">
                                        {translations.blocks.storageSizesAdvanced.lastOne}
                                    </div>
                                )}
                                {storage.hasFewLeft && (
                                    <div className="bg-gs-orange py-1 lg:py-2 w-full text-[0.875rem] sm:text-[1rem] font-color-white !mb-0">
                                        {translations.blocks.storageSizesAdvanced.fewLeft}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <div className={`relative w-full ${isSmallCard ? "" : "pb-[80%] mt-8"} md:max-w-[85%] mx-auto `}> {/* Set height to 80% of the width */}

                        <div className="absolute inset-0 flex items-center justify-center"> {/* Center image */}
                            <StorageSizeCardImage shortName={storage.shortName.trim()} imageAltText={ReplaceOrgName(translations.general.organization, temporaryOrgName)} country={country} useCustomStyling={useCustomStyling} />
                            {((storage.specialPrice && storage.specialPrice > 0) || storage.firstMonthDiscount) && (
                                <div className={`${styles.specialPriceLabelContainer}`}>
                                    <div className={`description ${styles.specialPriceLabel} ${styles.largeCard} bg-gs-orange font-color-white `}>
                                        {storage.firstMonthDiscount && (
                                            <>{`${translations.pages.facilityPage.cheapFirstMonthShort}*`}</>
                                        )}
                                        {!storage.firstMonthDiscount && storage.specialPrice && storage.specialPrice > 0 && (
                                            <>
                                                <span className="font-bold">{translations.pages.facilityPage.rightNow}</span>
                                                {` ${translations.general.fromShort} ${storage.specialPrice} ${translations.general.priceUnit} /${translations.general.shortMonth}*`}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <div className={`${isSmallCard ? "min-h-[0px]" : "min-h-[0px]"} mb-4`}>
                {isSmallCard && ((storage.specialPrice && storage.specialPrice > 0) || storage.firstMonthDiscount) && (
                    <div className={``}>
                        <div className={`description mb-1-i ${styles.specialPriceLabel} ${styles.smallCard} bg-gs-orange font-color-white `}>
                            {storage.firstMonthDiscount && (
                                <>{`${translations.pages.facilityPage.cheapFirstMonthShort}*`}</>
                            )}
                            {!storage.firstMonthDiscount && storage.specialPrice && storage.specialPrice > 0 && (
                                <>
                                    <span className="font-bold">{translations.pages.facilityPage.rightNow}</span>
                                    {` ${translations.general.fromShort} ${storage.specialPrice} ${translations.general.priceUnit} /${translations.general.shortMonth}*`}
                                </>
                            )}
                        </div>
                    </div>
                )}
                {(!storage.firstMonthDiscount || (!storage.firstMonthDiscount && storage.specialPrice !== undefined && storage.specialPrice > 0)) && (
                    <div className="text-xlarge font-bold !mb-0">
                        {`${!isSmallCard && !storage.isLastOne ? translations.general.fromShort : ""} ${storage.specialPrice !== undefined && storage.specialPrice > 0 ? storage.specialPrice : storage.price} ${translations.general.priceUnit} ${translations.general.longMonthLower}*`}
                    </div>
                )}

                {((storage.specialPrice > 0 && storage.specialPrice != storage.price) || storage.firstMonthDiscount) && (
                    <div className={`text-small`}>
                        {`${storage.firstMonthDiscount || (storage.specialPrice && storage.specialPrice > 0) ? `${translations.general.thereafter} ` : ""}${!isSmallCard && !storage.isLastOne ? translations.general.fromShort : ""} ${storage.price} ${translations.general.priceUnit} /${translations.general.shortMonth}*`}
                    </div>
                )}
            </div>
            {
                storage.isLastOne || isSmallCard || isOnSizeByAreaPage ? (
                    <LinkElement
                        title={translations.general.bookNow}
                        buttonColorTheme={eButtonColorTheme.Green}
                        chevronPosition={eChevronPosition.None}
                        href={storage.link}
                        isButton={true}
                        onClickAndLink={true}
                        onClick={handleLinkClick}
                        className={`w-full`}
                    >
                        {translations.blocks.storageSizesAdvanced.bookNow}
                    </LinkElement>
                ) : (
                    <>
                        {isOnStartPage ? (
                            <LinkElement
                                title={translations.blocks.storageSizesAdvanced.seeAll}
                                buttonColorTheme={eButtonColorTheme.Green}
                                chevronPosition={eChevronPosition.None}
                                onClick={handleLinkClick}
                                href={storage.link}
                                onClickAndLink={true}
                                isButton={true}
                                className={`w-full`}
                                renderAsALink={true}
                            >
                                {translations.blocks.storageSizesAdvanced.seeAll}
                            </LinkElement>
                        ) : (
                            <LinkElement
                                title={translations.blocks.storageSizesAdvanced.seeAll}
                                buttonColorTheme={eButtonColorTheme.Green}
                                chevronPosition={eChevronPosition.None}
                                onClick={handleLinkClick}
                                isButton={true}
                                className={`w-full`}
                            >
                                {translations.blocks.storageSizesAdvanced.seeAll}
                            </LinkElement>
                        )}
                    </>
                )
            }
        </div >
    );
}


